import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
  status: false,
};

export const postToken = createAsyncThunk(
  "token/postToken",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.refreshToken(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const tokenSlice = createSlice({
  name: "token",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(postToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(postToken.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(postToken.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const tokenList = (state) => state.token.value;

export default tokenSlice.reducer;
